import React from "react";
import styled from "styled-components";
import { TextView } from "@components";
import { ASSETS } from "../../../../../utils/config";

const AttachmentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px; // 'gap' property can be used to set spacing between grid items
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 15px;
`;

const Attachment = styled.div`
  border-radius: 8px;
  background-color: #f6f7f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 2px solid #e1e1e1;
  margin-left: 10px;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 10px;
`;

const DocImage = styled.img`
  width: 12vw;
  height: 5vh;
`;

const OpenButton = styled.div`
  background-color: #123051;
  border-radius: 20px;
  margin-top: 5px;
  width: 12vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  cursor: pointer;
`;

const OpenText = styled(TextView)`
  color: white;
  font-size: 8px;
`;

function Attachments({ attachments }) {
  return (
    <AttachmentWrapper>
      {attachments.map((e, index) => (
        <Attachment key={index}>
          <DocImage alt="Alt of img" src={ASSETS.pdfIcon} />
          <OpenButton onClick={() => window.open(e, "_blank")}>
            <OpenText>Open</OpenText>
          </OpenButton>
        </Attachment>
      ))}
    </AttachmentWrapper>
  );
}

export default Attachments;
